import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

export const VEHICLE_BUY_IN_REFRESH_STATUS_API_PATH = "/v1/vehicle-buy-in/{uuid}/refresh-status" as const;

export type VehicleBuyInRefreshStatusParameters =
  paths[typeof VEHICLE_BUY_IN_REFRESH_STATUS_API_PATH]["post"]["parameters"]["path"];

export function useVehicleBuyInRefreshStatusMutation() {
  return useMutation<void, Error, VehicleBuyInRefreshStatusParameters>({
    mutationFn: async ({ uuid }) => {
      const apiPath = VEHICLE_BUY_IN_REFRESH_STATUS_API_PATH.replace("{uuid}", uuid);
      await alphartisApiAxios.post<void>(apiPath);
    },
  });
}
